module.exports = __webpack_public_path__ + "img/instagramestory3.5f4d8e71.jpg";